document.addEventListener("DOMContentLoaded", function () {
    // console.log("working");
    const richtextContent = document.querySelector(".custom-collection-toggle .richtext-content");
    const button = document.querySelector(".custom-collection-toggle .button");

    console.log("button", button);

    if (richtextContent.offsetHeight === 200) {
        button.textContent = "Read more";
    } else {
        button.textContent = "Read less";
    }

    button.addEventListener("click", function (e) {
        e.preventDefault();
        const isCollapsed = richtextContent.offsetHeight === 200;

        if (isCollapsed) {
            richtextContent.style.height = "100%";
            button.textContent = "Read less";
        } else {
            richtextContent.style.height = "200px";
            button.textContent = "Read more";
        }
    });
});

$(document).ready(function(){
    $('.cstm-lbard-Engraving-acc-btn').click(function (e) {
        e.preventDefault();
            const chevron = $(this).find('.circle-chevron');
        $('.cstm-lbard-Engraving-acc-des').slideToggle(function () {
            chevron.css(
                'transform',
                chevron.hasClass('open') ? 'rotate(0deg)' : 'rotate(180deg)'
            );
            chevron.toggleClass('open');
        });
    });
});